import { render, staticRenderFns } from "./theme-item.vue?vue&type=template&id=faf413f4&scoped=true&"
import script from "./theme-item.vue?vue&type=script&lang=js&"
export * from "./theme-item.vue?vue&type=script&lang=js&"
import style0 from "./theme-item.vue?vue&type=style&index=0&id=faf413f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf413f4",
  null
  
)

export default component.exports